import * as API from "./vonLuckApi";

const fetchJSON = (path: string, opt: any) => fetch(path, opt).then((res) => res.json());
const fetchText = (path: string, opt: any) => fetch(path, opt).then((res) => res.text());

export const getAll = API.getAll(fetchJSON);
export const getById = API.getById(fetchJSON);
export const set = API.set(fetchJSON);
export const sendMail = API.sendMail(fetchText);
